/**
 * Define content for a card
 */
import React from 'react'

export const CardContent: React.FC = ({ children }) => <>{children}</>
